import {SnackbarProvider as NotistackSnackbarProvider} from 'notistack';
import React from 'react';

const SNACKBAR_ROOT_ID = 'snackbar-root';

export const SnackbarProvider: React.FCC = ({children}) => {
  const [rootEl, setRootEl] = React.useState<HTMLDivElement>();

  React.useEffect(() => {
    // Look for previously-created snackbar root
    let root = document.querySelector<HTMLDivElement>(`#${SNACKBAR_ROOT_ID}`);

    if (!root) {
      root = document.createElement('div');
      root.setAttribute('id', SNACKBAR_ROOT_ID);
      document.body.append(root);
    }

    setRootEl(root);
  }, []);

  return (
    <NotistackSnackbarProvider
      anchorOrigin={{
        // Bottom-right snackbars in sites-dot because the navbar will appear on top of any snackbars
        horizontal: 'right',
        vertical: 'bottom',
      }}
      /**
       * By default, snackbars render inline and use position fixed + z index to lay atop the screen.
       * Unfortunately, on mobile safari this doesn't always work due to layout bugs.
       * However, we can specify a root element and force the snackbar to render via a portal. This approach works on both desktop and mobile.
       */
      domRoot={rootEl}
      autoHideDuration={3000}
    >
      {children}
    </NotistackSnackbarProvider>
  );
};
